import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import alert from '../../../pages/admin/admin_assets/img/red_alert.svg';
import logo from '../../../pages/admin/admin_assets/img/logo.svg';
import menu1 from '../../../pages/admin/admin_assets/img/menu1.svg';
import menu2 from '../../../pages/admin/admin_assets/img/menu2.svg';
import menu3 from '../../../pages/admin/admin_assets/img/menu3.svg';
import axios from 'axios';
import config from '../../../config/config.js';
import '../../../pages/admin/admin_assets/css/sidebar.css';

const SideBar = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation(); 
  const navigate = useNavigate();
  const [role, setRole] = useState('');

  const [isPricingCollapsed, setPricingCollapsed] = useState(false);
  
useEffect(() => {
        const fetchUserData = async () => {
          try {
            const response = await axios.get(`${config.API_BASE_URL}/get-user-data.php`, {
              withCredentials: true,
            });
            
    
            if (response.data.success) {

              setRole(response.data.role || '');


            } else {
                navigate('/');
              console.error('Error fetching user data:', response.data.message);
            }
          } catch (error) {
            console.error('Error fetching user data:', error.response?.data?.message || error.message);
          }
        };
    
        fetchUserData();
      }, []);

  const handlePricingCollapseToggle = () => {
    setPricingCollapsed((prevState) => !prevState);
  };


  // Logout Popup
  const [modalShow, setModalShow] = useState(false);

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="logout_popup"
      >
        <Modal.Body>
          <img src={alert} alt="" />
          <p>Oh no! You’re about to log out from <strong>Brew Your Brand?</strong></p>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button onClick={props.onHide}>Keep Me Logged In</Button>
          <Button onClick={handleLogout}>Log Me Out</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const handleLogout = async () => {
    try {
        const response = await axios.post(`${config.API_BASE_URL}/logout.php`, {}, { withCredentials: true });
        console.log(response.data.message);
        window.location.href = "/admin"; // Redirect to login page
    } catch (error) {
        console.error("Logout failed:", error);
    }
};
  

  const sideBarOpen = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  // Helper function to determine if a path is active
  function isActive(path, checkSubPaths = false) {
    if (checkSubPaths) {
      const surveyRoutes = ['/admin/customer-form', '/admin/employee-form', '/admin/partner-form', '/admin/investor-form'];
      return location.pathname.startsWith(path) || surveyRoutes.some(route => location.pathname.includes(route));
    }
    return location.pathname === path;
  }




  return (
    <>
      <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
        <a className="sidebar-brand d-flex  align-items-center justify-content-left" href="/admin/overview">
          <div className="sidebar-brand-icon rotate-n-15" onClick={sideBarOpen}>
            <img src={logo} alt='RapidPricer'/>
          </div>
        </a>
        
      
        <li className={`nav-item ${isActive('/admin/overview',true) ? 'sidebaractive' : ''}`}>
          <Link className="nav-link " to="/admin/overview">
            <img src={menu1} style={{ width: '15px' }} />
            <span>Overview</span>
          </Link>
        </li>

        <li className={`nav-item ${isActive('/admin/surveys',true) ? 'sidebaractive' : ''}`}>
          <Link className="nav-link" to="/admin/surveys">
            <img src={menu3} style={{ width: '15px' }} />
            <span>Survey Templates</span>
          </Link>
        </li>

        <li className={`nav-item ${isActive('/admin/ebook', true) ? 'sidebaractive' : ''}`}>
          <button
            className={`nav-link collapsed d-flex justify-content-between align-items-center`}
            onClick={handlePricingCollapseToggle}
            aria-expanded={isPricingCollapsed}
            aria-controls="collapseTwo"
          >
            <div className="d-flex d-sm-block align-items-center">
              <img src={menu2} style={{ width: '15px' }} alt="Price Icon" />
              <span className="">eMagazine</span>
            </div>
            <i className={`bi ${isPricingCollapsed ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
          </button>

          {/* Submenus */}
          <div
            id="collapseTwo"
            className={`collapse ${isPricingCollapsed ? 'show' : ''}`}
            aria-labelledby="headingTwo"
            data-parent="#accordionSidebar"
          >
            <div className="py-2 collapse-inner rounded">
              <Link className={`collapse-item ${isActive('/admin/categories') ? 'text-white' : ''}`} to="/admin/categories">
                Categories
              </Link>
              <Link className={`collapse-item ${isActive('/admin/tags') ? 'text-white' : ''}`} to="/admin/tags">
                Tags
              </Link>

              <Link className={`collapse-item ${isActive('/admin/blog') ? 'text-white' : ''}`} to="/admin/blog">
                Blog
              </Link>
              <Link className={`collapse-item ${isActive('/admin/subscribers') ? 'text-white' : ''}`} to="/admin/subscribers">
              Subscribers
              </Link>
              <Link className={`collapse-item ${isActive('/admin/meta-tags') ? 'text-white' : ''}`} to="/admin/meta-tags">
              Meta Tags
              </Link>
            </div>
          </div>
        </li>

        <li className={`nav-item ${isActive('/quick-brand-leads', true) || isActive('/admin/brand-audit', true) ? 'sidebaractive' : ''}`}>
          <Link className="nav-link" to="/quick-brand-leads">
            <img src={menu3} style={{ width: '15px' }} />
            <span>Quick Brand Leads</span>
          </Link>
        </li>

      {role === 'Admin' && (
  <li className={`nav-item ${isActive('/admin/user-management', true) ? 'sidebaractive' : ''}`}>
    <Link className="nav-link" to="/admin/user-management">
      <img src={menu3} style={{ width: '15px' }} />
      <span>User Management</span>
    </Link>
  </li>
)}



        <li style={{ marginTop: 'auto' }}></li>
        
        <li className="nav-item setting">
          <Link className="nav-link " to="/admin/setting">
            <img src="https://purple-pond-055ead403.4.azurestaticapps.net/img/setting.svg" alt="Settings" className="set_icon" />
            <span style={{ color: '#fff' }}>Settings</span>
          </Link>
        </li>
        
        <li className="nav-item border-0 logout">
          <Link className="nav-link" onClick={() => setModalShow(true)}>
            <img src="https://purple-pond-055ead403.4.azurestaticapps.net/img/logout.svg" alt="Logout" className="set_icon" />
            <span style={{ color: '#fff' }}>Logout</span>
          </Link>
        </li>

        

      </ul>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default SideBar;
